import axios from 'axios';
import { CourseSearchItem, SavedCourseSummary, SavedCourseDetail } from '../types';
import { attachAuthInterceptor } from './authToken';

const BASE_URL = process.env.REACT_APP_CLUBHOUSE_API_URL || 'http://localhost:5000';

const apiClient = axios.create({
  baseURL: `${BASE_URL}/api`,
});
attachAuthInterceptor(apiClient);

export const courseApi = {
  search: async (q: string, state?: string): Promise<CourseSearchItem[]> => {
    const params = new URLSearchParams();
    if (q) params.append('q', q);
    if (state) params.append('state', state);
    const { data } = await apiClient.get<CourseSearchItem[]>(`/courses/search?${params.toString()}`);
    return data;
  },

  listSaved: async (): Promise<SavedCourseSummary[]> => {
    const { data } = await apiClient.get<SavedCourseSummary[]>('/courses');
    return data;
  },

  getSaved: async (id: number): Promise<SavedCourseDetail> => {
    const { data } = await apiClient.get<SavedCourseDetail>(`/courses/${id}`);
    return data;
  },

  /** Full course by OpenGolf id; the server downloads it from OpenGolf only the first time any golfer needs it. */
  getByExternalId: async (externalId: string): Promise<SavedCourseDetail> => {
    const { data } = await apiClient.get<SavedCourseDetail>(`/courses/external/${encodeURIComponent(externalId)}`);
    return data;
  },
};
